import { defineComponent as _defineComponent } from 'vue'
import { ref, onBeforeMount, computed } from "vue";
  import store from "../../store/index";
  import router from "../../router/index";
  import { formatPrice } from "@/helpers/transformation/price";
  import { LotInterface } from "@/types/LotInterface";
  import { getEoiLogoUrl } from "@/helpers/eoi/getEoiLogoUrl";
  import { EstateInterface } from "@/types/EstateInterface";

  interface Props {
    lot: LotInterface;
    estate: EstateInterface;
    businessId: string | null;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'LotCard',
  props: {
    lot: {},
    estate: {},
    businessId: {}
  },
  emits: [""],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;
  const props = __props;

  const businessId = computed(() => {
    return (router.currentRoute.value.query?.businessId as string) ?? null;
  });
  const logoUrl = computed(() => {
    if (!props.estate) return "";

    return getEoiLogoUrl(props.estate, businessId.value);
  });

  function getDate() {
    if (!props.lot?.releaseDate) {
      return "-";
    } else {
      const releaseDate = new Date(props.lot.releaseDate);
      const arrDate = releaseDate.toDateString().split(" ");

      return `${arrDate[2]} ${arrDate[1]} ${arrDate[3]}`;
    }
  }

const __returned__ = { emits, props, businessId, logoUrl, getDate, ref, onBeforeMount, computed, get store() { return store }, get router() { return router }, get formatPrice() { return formatPrice }, get LotInterface() { return LotInterface }, get getEoiLogoUrl() { return getEoiLogoUrl }, get EstateInterface() { return EstateInterface } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})